import { render, staticRenderFns } from "./comDetails.vue?vue&type=template&id=6f657ce2&scoped=true"
import script from "./comDetails.vue?vue&type=script&lang=js"
export * from "./comDetails.vue?vue&type=script&lang=js"
import style0 from "./comDetails.vue?vue&type=style&index=0&id=6f657ce2&prod&lang=scss&scoped=true"
import style1 from "./comDetails.vue?vue&type=style&index=1&id=6f657ce2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f657ce2",
  null
  
)

export default component.exports